<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card configurator" v-bind:id="getCompId()" style="float:left; width:200px;">
    <div class="card-header bg-dark text-white header-elements-inline">
      <h6 class="card-title">{{$t('date_filter')}}</h6>
      <div class="header-elements">
        <div class="list-icons">
          <a class="list-icons-item" @click="removeMe" data-action="remove"></a>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="container-fluid upload-container p-0">
        <div class="row">
          <div class="input-container col-sm-12 px-0" style="float:left;">
            <input type="text" class="form-control calendarassignment" name="startdate" v-bind:id="'txt_startdate_' +  getId()"  />
            
          </div>
          <div class="input-container col-sm-12 px-0" style="float:left;">
            <input type="text" class="form-control calendarassignment" name="enddate" v-bind:id="'txt_enddate_' +  getId()"  />          </div>
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-sm-12 px-0">
          <button class="btn btn-success btn-sm col-sm-12" @click="doApply">{{$t('apply')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var config =
  {
    customstyle: "background-color:#B6E874",
    customclass: "",
    abbreviation: null,
    data: 8,
    icon: "/images/filter_icons/icon-location.png",
    text: "Date Filter"
  }

  export default {
    name: "config-date",
    components: {

    },
    props: {
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        config,
        selectedstartdate: '',
        selectedenddate: '',
      };
    },

    methods: {
      doApply() {
        var startDate = new Date($("#txt_startdate_" + this.getId()).val());
        var endDate = new Date($("#txt_enddate_" + this.getId()).val());

        var d = startDate.toISOString() + ',' + endDate.toISOString();        
        var configCopy =
        {
          customstyle: this.config.customstyle,
          customclass: this.config.customclass,
          abbreviation: this.config.abbreviation,
          data: d,
          icon: this.config.icon,
          text: this.config.text
        };

        this.$emit('addFilter', this.type, configCopy);
      },
      init() {       
        $('.calendarassignment').daterangepicker({
          singleDatePicker: true,
          showDropdowns: true,
          minYear: 1901,
          maxYear: parseInt(moment().format('YYYY'), 10),
          locale: {
            format: 'YYYY-MM-DD'
          }
        });
      },
      getId() {
        return this._uid;
      },
      getCompId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getCompId());
      }
    },
    computed: {

    },
    mounted() {
     //TODO: temp. fix need to check later
      setTimeout(this.init, 1);
    },

    created: function () {
    },

    watch: {

    },
    created() {
      //alert($("#sunil13546564664").val());
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>
  .configurator {
    margin-left: 15px;
  }

  .card-header.bg-dark {
    background-color: #EAEDEF !important;
    color: black !important;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/filter/configurators/config-date.vue